document.addEventListener('DOMContentLoaded', function () {
    const stikyContainers = document.querySelectorAll('[sticky-group]');
    
    if (stikyContainers) {

        stikyContainers.forEach(container => {
            
            const source = container.querySelector('[sticky-source]');
            const item = container.querySelector('[sticky-target]');

            console.log(source.offsetHeight, item.offsetHeight);
            if (source.offsetHeight > item.offsetHeight + 30) {
                container.classList.add('row-align-start');
            }
        });
    }
});